import React, { useEffect, useState } from 'react';
import Loader from "../../components/Loader"; 
import Paginator from "../../components/Paginator"; 
import ApiService from "../../services/ApiService";
import { Link } from 'react-router-dom';
import { formatDate } from '../../utils/helper';
import moment from 'moment';

const List = () => {
    
    const [isLoader, setIsLoader] = useState(false);
    const [appointments, setAppointments] = useState([]);
    const [pagination, setPagination] = useState({});
    
    const [apiData, setApiData] = useState({
        from_month: moment().format('YYYY-MM'),
        to_month: moment().format('YYYY-MM'),
        specialist_recommended: "",
        contact_status: "",
        page: 1,
    });

    const [contactingId, setContactingId] = useState(null);

    useEffect(() => {
        getAppointments();
    }, [apiData.page, apiData.from_month, apiData.to_month, apiData.specialist_recommended, apiData.contact_status]); 

    const getAppointments = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "admin/appointment-reminders", 
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setAppointments(data.data.appointments || []);
                setPagination(data.data.pagination || {});
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoader(false);
        }
    };

    const handleFromMonthChange = (e) => {
        setApiData(prev => ({ ...prev, from_month: e.target.value, page: 1 }));
    };

    const handleToMonthChange = (e) => {
        setApiData(prev => ({ ...prev, to_month: e.target.value, page: 1 }));
    };

    const handleSpecialistFilterChange = (e) => {
        setApiData(prev => ({ ...prev, specialist_recommended: e.target.value, page: 1 }));
    };

    const handleContactStatusChange = (e) => {
        setApiData(prev => ({ ...prev, contact_status: e.target.value, page: 1 }));
    };

    const handleMarkContacted = async (id) => {
        try {
            setContactingId(id);
            const response = await ApiService.request({
                method: "POST",
                url: `admin/appointment-reminders/${id}/contact`,
            });
            if (response.data.status) {
                setAppointments(prev =>
                    prev.map(item =>
                        item.id === id ? { ...item, reminder_contacted: true } : item
                    )
                );
            }
        } catch (error) {
            console.error(error);
        } finally {
            setContactingId(null);
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-fluid d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                            Appointment Reminders
                        </h1>
                    </div>
                </div>
            </div>

            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-fluid">
                    <div className="card">
                            <div className="card-header border-0 pt-6">
                                <div className="card-title">
                                    <div className="d-flex align-items-center position-relative my-1 gap-4 flex-wrap">
                                        <div className="position-relative">
                                            <label className="form-label fs-7 fw-bold">From Month</label>
                                            <input
                                                type="month"
                                                className="form-control form-control-solid w-200px"
                                                value={apiData.from_month}
                                                onChange={handleFromMonthChange}
                                            />
                                        </div>
                                        <div className="position-relative">
                                            <label className="form-label fs-7 fw-bold">To Month</label>
                                            <input
                                                type="month"
                                                className="form-control form-control-solid w-200px"
                                                value={apiData.to_month}
                                                onChange={handleToMonthChange}
                                            />
                                        </div>
                                        <div className="position-relative">
                                            <label className="form-label fs-7 fw-bold">Specialist Recommended</label>
                                            <select
                                                className="form-select form-select-solid w-200px"
                                                value={apiData.specialist_recommended}
                                                onChange={handleSpecialistFilterChange}
                                            >
                                                <option value="">All</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </select>
                                        </div>
                                        <div className="position-relative">
                                            <label className="form-label fs-7 fw-bold">Contact Status</label>
                                            <select
                                                className="form-select form-select-solid w-200px"
                                                value={apiData.contact_status}
                                                onChange={handleContactStatusChange}
                                            >
                                                <option value="">All</option>
                                                <option value="not_contacted">Not Contacted</option>
                                                <option value="contacted">Contacted</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        <div className="card-body pt-0">
                            <div className="table-responsive">
                                <table className="table align-middle table-row-dashed fs-6 gy-5">
                                    <thead>
                                        <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                            <th className="min-w-100px">Ref No</th>
                                            <th className="min-w-150px">Patient</th>
                                            <th className="min-w-100px">Phone</th>
                                            <th className="min-w-125px">Checkup Date</th>
                                            <th className="min-w-125px">Next Visit</th>
                                            <th className="min-w-100px">Specialist Rec.</th>
                                            <th className="min-w-125px">Contact Status</th>
                                            <th className="min-w-100px">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody className="fw-semibold text-gray-600">
                                        {isLoader ? (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        ) : appointments.length > 0 ? (
                                            appointments.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.ref_no}</td>
                                                    <td>
                                                        <div className="d-flex align-items-center">
                                                            <div className="d-flex flex-column">
                                                                <span className="text-gray-800 text-hover-primary mb-1">{item.patient?.name}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>{item.patient?.phone}</td>
                                                    <td>{formatDate(item.date)}</td>
                                                    <td>
                                                        <span className="badge badge-light-primary">
                                                            {item.doctor_records?.next_visit || '-'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {item.doctor_records?.specialist_recommendation === 'Yes' ? (
                                                            <span className="badge badge-light-danger">Yes</span>
                                                        ) : (
                                                            <span className="badge badge-light-secondary">No</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {item.reminder_contacted ? (
                                                            <span className="badge badge-light-success">Contacted</span>
                                                        ) : (
                                                            <span className="badge badge-light-warning">Not Contacted</span>
                                                        )}
                                                    </td>
                                                    <td className="d-flex gap-2">
                                                        <Link 
                                                            to={`/appointments/${item.id}/checkup`} 
                                                            className="btn btn-sm btn-light btn-active-light-primary"
                                                        >
                                                            View
                                                        </Link>
                                                        {!item.reminder_contacted && (
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-light btn-active-light-success"
                                                                onClick={() => handleMarkContacted(item.id)}
                                                                disabled={contactingId === item.id}
                                                            >
                                                                {contactingId === item.id ? 'Marking...' : 'Mark Contacted'}
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center">
                                                    No reminders found for this month
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <Paginator
                                pagination={pagination}
                                onPageChange={(page) => setApiData(prev => ({ ...prev, page }))}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
